<template>
  <vbt-content-box
    :loading="loading"
    :loading-error="loadingError"
    :no-content="noContent"
    title="History"
  >
    <vbt-table
      :headers="headers"
      :items="packageReturnHistory"
      show-paginator
    >
      <template #processDate="{ item: { processDate: _date } }">
        {{ formatDate(_date) }}
      </template>
    </vbt-table>
  </vbt-content-box>
</template>

<script>
import { mapState } from 'vuex';

import { useIncludedLoading } from '@mixins/factories';

import { formatDate } from '@helpers';

import { namespace as PackageReturnsNamespace } from '../store.types';

const headers = Object.freeze([
  { text: 'Operator', value: 'operator' },
  { text: 'Process Date', value: 'processDate' },
  { text: 'Description', value: 'description' },
]);

export default {
  name: 'KernelPackageReturnHistory',

  mixins: [
    useIncludedLoading(),
  ],

  data() {
    return {
      headers,
    };
  },

  computed: {
    ...mapState(PackageReturnsNamespace, {
      packageReturnHistory: ({ packageReturn: { history: items } }) => items || [],
    }),

    noContent() {
      return {
        show: !this.packageReturnHistory.length,
        msg: 'No content',
      };
    },
  },

  methods: {
    formatDate,
  },
};
</script>
